/** @file Removes a reference image (the registered image itself stays). */
import { defineCommand } from '../defineCommand';
import { defineRemove } from '../_shared/defineRemove';

/** reference.remove: the defineRemove factory under the spec name. */
export const command = defineCommand({
  ...defineRemove({ domain: 'reference', kind: 'reference', description: 'Remove a reference image (the image stays registered; image.delete removes it once unused).' }),
  name: 'reference.remove',
});
